// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"TaskBar_progressBar__q4Phn","outerContainer":"TaskBar_outerContainer__3GBmD","deleteBin":"TaskBar_deleteBin__Ctax1"};